import { Helmet } from 'react-helmet';
import RegisterCompanyStepForm from './RegisterCompanyStepForm/RegisterCompanyStepForm';

export default () => {
  return (
    <>
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <RegisterCompanyStepForm />
    </>
  );
};
